<template>
  <div
    class="tabs-container ng-scope"
    style="padding-bottom: 50px; margin-top: 18px"
  >
    <el-form
      :model="category"
      ref="category"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card">
        <el-tab-pane label="English">
          <div class="form-group">
            <label class="col-sm-2 control-label">
              Sub-Category Name
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <el-form-item
                prop="categoryNameEn"
                :rules="[
                  {
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="category.categoryNameEn"
                  :name="'categoryNameEn'"
                  maxlength="30"
                  show-word-limit
                />
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Simplified Chinese">
          <div class="form-group">
            <label class="col-sm-2 control-label">
              Sub-Category Name
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <el-form-item
                prop="categoryNameSc"
                :rules="[
                  {
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="category.categoryNameSc"
                  :name="'categoryNameSc'"
                  maxlength="30"
                  show-word-limit
                />
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Simplified Chinese">
          <div class="form-group">
            <label class="col-sm-2 control-label">
              Sub-Category Name
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <el-form-item
                prop="categoryNameTc"
                :rules="[
                  {
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="category.categoryNameTc"
                  :name="'categoryNameTc'"
                  maxlength="30"
                  show-word-limit
                />
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>
        <div class="form-group" style="display: none">
          <label class="col-sm-2 control-label"> Cover Image </label>
          <div class="col-sm-10">
            <el-upload
              class="upload-demo upload-image"
              action="#"
              multiple
              :http-request="uploadFile"
              :auto-upload="true"
              accept=".png, .jpg , .jpeg"
              :show-file-list="false"
            >
              <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The uploaded file should not exceed 5MB</div>
              <div class="input-group img-group">
                <div class="text-center dropzone logo">
                  <div
                    class="addImage"
                    v-if="!category.fileUrl"
                    style="width: 100%; padding-top: 25px; color: #fff"
                  >
                    <a class="addImageIcon btn btn-primary btn-circle">
                      <i class="el-icon-upload2"></i>
                    </a>
                    <p class="text-primary m-t-sm font14 suggestFont">
                      <slot name="sizeHint"></slot>
                    </p>
                  </div>
                  <div class="editImage" v-if="showFileUrl">
                    <div class="mask-bg"></div>
                    <img :src="showFileUrl" />
                    <div class="icon-center">
                      <span class="edit-icon">
                        <i class="el-icon-edit"></i>
                      </span>
                      <p class="font14 font-white editFont">Modify</p>
                      <p
                        class="
                          text-primary
                          font-white
                          m-t-sm
                          font14
                          suggestFont
                        "
                      >
                        <slot name="sizeHint"></slot>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </el-upload>
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-12">
            <div class="pull-right">
              <el-button
                type="primary"
                v-if="
                  ($route.query.id) || (!$route.query.id)
                "
                @click="checkEvent()"
              >
                {{ $t("message.Save") }}
              </el-button>
              <el-button @click="handleBack($router.go(-1))">{{
                $t("message.Cancel")
              }}</el-button>
            </div>
          </div>
        </div>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import sha256 from "sha256";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      showFileUrl: "",
      category: {
        categoryCode: "",
        categoryNameEn: "",
        categoryNameSc: "",
        categoryNameTc: "",
        fileUrl: "",
      },
      uploadErr:false
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    checkEvent() {
      this.$refs["category"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    async uploadFile(params) {
      if(!this.handleCheckUploadFileSize(params.file)) return false
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == this.TOKEN_EXPIRED) {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.category.fileUrl = data.data.result.url;
      this.showFileUrl = data.data.result.showUrl;
    },
    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.categoryDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (data.data.result.startTime) {
          this.period = [data.data.result.startTime, data.data.result.endTime];
        }
        if (!data) return;
        for (var key in this.category) {
          this.category[key] = data.data.result[key];
        }
        //this.$set(this, "category", data.data.result);
        this.showFileUrl = data.data.result.showFileUrl;

        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      } else {
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      }
    },
    async submit() {
      let obj = this.getAuthObj();

      for (var key in this.category) {
        obj[key] = this.category[key];
      }
      var data;
      if (this.$route.query.id) {
        obj.id = this.$route.query.id;
        obj.apiUrl = this.apiConfig.categoryUpdate;
        data = await this.$store.dispatch("apiEvent", obj);
      } else {
        obj.apiUrl = this.apiConfig.categoryCreate;
        data = await this.$store.dispatch("apiEvent", obj);
      }
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$router.go(-1);
      }
    },
    handleCheckUploadFileSize(file){
      const sizeKB = file.size/1024
      if(sizeKB>5120){
        this.uploadErr = true
        return false
      }else{
        this.uploadErr = false
        return true
      }
    }
  },
};
</script>
